import styled, { css } from "styled-components";

export const commonStyles = css`
  .containerCupomListagem {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    .textoCupom{
      text-align: left;
      padding: 3rem 0 0;
      width: 100%;
      color: ${(props) => props.theme.colors.tertiary};
      position: relative;
    }

    .linha{
      width: 30%;
      height: 2px;
      border-radius: 100%;
      background-color: ${(props) => props.theme.colors.elements};
    }

    .filtros-cupom{
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 2rem;

      .busca-listagem{
        flex-grow: 1;
      }

      .select-filtro-cupons{
        width: 20%;

        @media (max-width: 768px) {
          width: 40%;
        }
      }
    }

    .rodapeListagem {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr auto 1fr;
      align-items: center;
      gap: 2rem;

      .paginacaoListagem > div {
        justify-content: flex-start;
      }

      @media (max-width: 768px) {
        display: flex;
        flex-direction: column;

        .paginacaoListagem > div {
          justify-content: center;
        }
      }
    }

    .tableContainer{
      >table{
        >thead{
          >tr{
            >th{
              .th-wrapper{
                padding: 2rem;
              }
            }
          }
        }
      }
      .editar{
        color: ${(props) => props.theme.colors.primary};
        cursor: pointer;
      }
    }

    > .novo, .rodapeListagem .novo {
      text-align: center;
      color: ${(props) => props.theme.colors.primary};
      cursor: pointer;
      min-height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const ContainerCupomListagem = styled.div<{
    configIn: "empresa" | "configuracoes";
}>`
  ${commonStyles};
  ${({ configIn }) =>
        configIn === "configuracoes" &&
        css`
      .containerCupomListagem {
        width: 100%;
        .novo {
          text-align: center;
        }
      }
    `}
`;
